var site = site || {};
site.inits = [];

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	initVideoCarousel: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
		let videos = document.querySelectorAll(id + ' video');

		let mutationCallback = (mutationsList, observer) => {
			mutationsList.forEach(mutation => {
				const target = mutation.target;
				const targetVideo = target.querySelector('video');

				if (mutation.attributeName === 'class') {
					if (target.classList.contains('active')) {
						targetVideo.pause();
						targetVideo.currentTime = 0;
						targetVideo.play(); // start the video from the beginning when it is in view
					}
				}
			});
		};

		let mutationObserver = new MutationObserver(mutationCallback);
		let owlItems = document.querySelectorAll(id + ' .owl-item');

		videos.forEach(vid => {
			vid.addEventListener('ended', (ev) => {
				$owl.trigger('next.owl.carousel');
				console.log('owl carousel next triggered');
			});
		});

		owlItems.forEach(item => {
			mutationObserver.observe(item, {attributes: true})
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	site.owl.initVideoCarousel('.video__carousel', {
		items: 1,
		loop: true,
	});
});
